export default {
  sm: `
    The challenge of 
    globally connected
    DATA CENTER GAK continues.
  `,
  md: `
    The challenge of globally connected
    DATA CENTER GAK continues.
  `,
};
